import { ArrowLeft } from "lucide-react";
import { NavLink as Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="not-found container mx-auto">
      <div className="flex flex-col items-center justify-center gap-4 text-center">
        <div className="px-3 flex">
          <img
            className="m-auto w-3/4"
            src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/not-found.png"
            alt="غير موجود"
          />
        </div>
        <Link
          to="/"
          className="m-auto flex text-white items-center gap-4 p-2 bg-primary rounded-lg"
        >
          <p className="font-bold text-xl">الرجوع للصفحة الرئيسية</p>
          <ArrowLeft className="size-7" />
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
